import { render, staticRenderFns } from "./BuildingEditor.vue?vue&type=template&id=4a2d484f&"
import script from "./BuildingEditor.vue?vue&type=script&lang=ts&"
export * from "./BuildingEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports